import { render, staticRenderFns } from "./DigitalDocuments.vue?vue&type=template&id=2d4cccde&"
import script from "./DigitalDocuments.vue?vue&type=script&lang=js&"
export * from "./DigitalDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports